export default __webpack_public_path__ + "images/EB.b61e152.png";